/*
 * Public API Surface of core
 */

export * from './lib/components/crud-table/crud-table.component';
export * from './lib/components/dialog/dialog.component';
export * from './lib/components/fields/fields.component';
export * from './lib/components/loading-animation/loading-animation.component';
export * from './lib/components/menu-list/menu-list.component';
export * from './lib/components/sub-menu-list/sub-menu-list.component';

export * from './lib/interfaces/field';
export * from './lib/interfaces/form.interface';
export * from './lib/interfaces/button';
export * from './lib/interfaces/async-response';
export * from './lib/interfaces/menu';
export * from './lib/interfaces/media';
export * from './lib/interfaces/user-interface';
export * from './lib/interfaces/tab';
export * from './lib/interfaces/search-entry';
export * from './lib/interfaces/search-object';
export * from './lib/interfaces/paginated-response';
export * from './lib/interfaces/link';
export * from './lib/interfaces/media-upload-status';
export * from './lib/interfaces/module.interface';
export * from './lib/interfaces/paginated-response';
export * from './lib/interfaces/table-column.interface';
export * from './lib/interfaces/crud-config.interface';
export * from './lib/interfaces/dialog';
export * from './lib/interfaces/crud-page-change.interface';

export * from './lib/modules/material.module';
export * from './lib/core.module';